/* src/app/components/opening-hours/opening-hours.component.scss */
.yf-oh {
  width: 100%;
}
.yf-oh--full {
  width: 100%;
}
.yf-oh__toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  margin: 0;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.yf-oh__chev {
  flex: 0 0 auto;
  font-size: 18px;
  color: #8a929b;
  transition: transform 0.2s ease;
}
.yf-oh__chev--open {
  transform: rotate(180deg);
}
.yf-oh__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 6px;
}
.yf-oh__hint {
  display: block;
  line-height: 1.35;
  color: #5f7180;
}
.yf-oh__dayname {
  color: var(--ion-color-dark);
}
.yf-oh__hours {
  color: #5f7180;
}
.yf-oh__week {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}
.yf-oh__day {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 3px 0;
}
.yf-oh__day--today ion-text {
  font-weight: 700;
}
.oh--open {
  color: #3d7a10;
}
.oh--soon {
  color: #9a6400;
}
.oh--chargeable {
  color: #1f6f9e;
}
.oh--closed {
  color: #9a6400;
}
/*# sourceMappingURL=opening-hours.component.css.map */
